const Modal = () => ({
    show: false,
    title: null,
    content: null,
    actions: null,
    nav: null,

    init() {
        this.nav = document.querySelector('nav.sticky');
    },

    openModal({ title, content, actions }) {
        this.title = title;
        this.content = content;
        this.actions = actions;
        this._protectBody();
        this.show = true;
    },

    closeModal(param) {
        const { finishCb } = param;
        this.show = false;
        setTimeout(function () {
            this._unprotectBody();
            this.title = null;
            this.content = null;
            this.actions = null;

            if (finishCb) finishCb();
        }.bind(this), 200);
    },

    _protectBody() {
        document.body.classList.add('overflow-hidden');
        this.nav.classList.remove('sticky');
    },

    _unprotectBody() {
        document.body.classList.remove('overflow-hidden');
        this.nav.classList.add('sticky');
    }
});

export default Modal;